import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CloseIcon } from "../../../../assets/close_icon.svg"
import { MobileMenuProps, NavigationCategory } from "src/utils/types/NavigationTypes";
import { SERVICES_MENU, CONTACT_MENU } from "src/utils/types/NavigationLinks";


const MobileMenu: FunctionComponent<MobileMenuProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;


  return (
    <MobileMenuOverlay>
      <MenuHeader onClose={onClose} />
      <MenuContent onLinkClick={onClose} />
    </MobileMenuOverlay>
  );
};

const MobileMenuOverlay: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => (
  <div className="absolute top-0 left-0 w-screen h-screen bg-white z-50 p-4 mobile-menu-overlay">
    <div className="mobile-menu-content">
      {children}
    </div>
  </div>
);

const MenuHeader: FunctionComponent<{ onClose: () => void }> = ({ onClose }) => (
  <div className="flex justify-end mb-8">
    <CloseIcon 
      height={30} 
      width={30} 
      onClick={onClose} 
      className="cursor-pointer" 
    />
  </div>
);

const MenuContent: FunctionComponent<{ onLinkClick: () => void }> = ({ onLinkClick }) => (
  <div className="flex flex-col space-y-8">
    <HomeLink onLinkClick={onLinkClick} />
    <ServicesSection onLinkClick={onLinkClick} />
    <ContactSection onLinkClick={onLinkClick} />
    <LoginLink onLinkClick={onLinkClick} />
  </div>
);

const HomeLink: FunctionComponent<{ onLinkClick: () => void }> = ({ onLinkClick }) => (
  <Link to="/" onClick={onLinkClick} className="text-2xl font-bold">
    Home
  </Link>
);

const ServicesSection: FunctionComponent<{ onLinkClick: () => void }> = ({ onLinkClick }) => (
  <MenuSection title="Services" items={SERVICES_MENU} onLinkClick={onLinkClick} />
);


const ContactSection: FunctionComponent<{ onLinkClick: () => void }> = ({ onLinkClick }) => (
  <MenuSection title="Contact" items={CONTACT_MENU} onLinkClick={onLinkClick} />
);


const MenuSection: FunctionComponent<{
  title: string;
  items: NavigationCategory[];
  onLinkClick: () => void;
}> = ({ title, items, onLinkClick }) => (
  <div>
    <SectionTitle title={title} />
    <SectionCategories items={items} onLinkClick={onLinkClick} />
  </div>
);


const SectionTitle: FunctionComponent<{ title: string }> = ({ title }) => (
  <h3 className="text-xl font-bold mb-4">{title}</h3>
);


const SectionCategories: FunctionComponent<{
  items: NavigationCategory[];
  onLinkClick: () => void;
}> = ({ items, onLinkClick }) => (
  <>
    {items.map((category, index) => (
      <CategoryGroup key={index} category={category} onLinkClick={onLinkClick} />
    ))}
  </>
);


const CategoryGroup: FunctionComponent<{
  category: NavigationCategory;
  onLinkClick: () => void;
}> = ({ category, onLinkClick }) => (
  <div className="mb-4">
    {category.category && (
      <CategoryTitle title={category.category} />
    )}
    <CategoryLinks links={category.links} onLinkClick={onLinkClick} />
  </div>
);


const CategoryTitle: FunctionComponent<{ title: string }> = ({ title }) => (
  <h4 className="font-semibold text-primary mb-2">{title}</h4>
);


const CategoryLinks: FunctionComponent<{
  links: Array<{ name: string; link: string }>;
  onLinkClick: () => void;
}> = ({ links, onLinkClick }) => (
  <div className="flex flex-col space-y-2 ml-4">
    {links.map((link, linkIndex) => (
      <Link
        key={linkIndex}
        to={link.link}
        onClick={onLinkClick}
        className="text-gray-700 hover:text-primary"
      >
        {link.name}
      </Link>
    ))}
  </div>
);


const LoginLink: FunctionComponent<{ onLinkClick: () => void }> = ({ onLinkClick }) => (
  <Link to="/auth/login" onClick={onLinkClick} className="text-2xl font-bold text-primary">
    Login
  </Link>
);


export default MobileMenu;




